// extracted by mini-css-extract-plugin
export default {"subMenu":"DropdownDesktop_subMenu__xaMKh","subItem":"DropdownDesktop_subItem__CG1S1","dropdown":"DropdownDesktop_dropdown__lGv71","sub-menu":"DropdownDesktop_sub-menu__2mXBn"};